<template>
    <img src="/img/logo.svg" alt="">
</template>

<script>
export default {
}
</script>

<style>

</style>